export const TextArea = (props: {
  label: string;
  value: string | number | null | undefined;
  placeholder?: string;
  rows?: number;
  onKeyDown?: (e: { currentTarget: { value: string }; key: string }) => void;
  onChange?: (e: { target: { value: string } }) => void;
  onInput?: (e: { target: { value: string } }) => void;
  disabled?: boolean;
  required?: boolean;
  error?: string | string[] | null | boolean;
  ref?: (el: HTMLTextAreaElement) => void;
  maxChar?: number;
  infoText?: string;
}) => {
  const hasError = () => {
    return (
      props.error !== false &&
      props.error !== null &&
      props.error !== undefined &&
      (Array.isArray(props.error) ? props.error.length > 0 : props.error !== '')
    );
  };

  return (
    <div class="relative my-1">
      <textarea
        class={`peer w-full px-3 py-2 border-[1px] rounded-md shadow-sm focus:outline-none
          disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-500 border-[#80b6cf] focus:border-[#123b50] hover:border-[#123b50]
          placeholder:opacity-0 focus:placeholder:opacity-100
          resize-y min-h-[80px]
          ${hasError() ? 'border-error-red focus:border-error-red hover:border-error-red' : ''}`}
        value={props.value ?? ''}
        onChange={props.onChange}
        onInput={props.onInput}
        onKeyDown={props.onKeyDown}
        placeholder={props.placeholder ?? ''}
        ref={props.ref}
        disabled={props.disabled}
        maxLength={props.maxChar}
        rows={props.rows ?? 4}
      />
      <label
        class={`text-shadow absolute bg-transparent left-2 px-1 text-sm font-medium transition-all duration-200 ease-out pointer-events-none -top-2.5
          peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-gray-500 peer-focus:-top-2.5 peer-focus:text-sm peer-disabled:text-gray-400
          ${hasError() ? 'text-error-red peer-focus:text-error-red' : 'text-armstrong-primary peer-focus:text-armstrong-primary'}`}
      >
        {props.label}
        {props.required && <span class="text-error-red bg-white"> *</span>}
      </label>
      {props.error && (
        <div class="text-error-red text-xs mt-1 px-2">{props.error}</div>
      )}
      {(props.infoText || props.maxChar) && (
        <div class="flex justify-between text-armstrong-blue text-xs mt-1 px-2">
          {props.infoText && <div>{props.infoText}</div>}
          {props.maxChar && (
            <div>
              {String(props.value ?? '').length}/{props.maxChar}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
